"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildAdultReasoningTimeline;
// setup
const helpers_1 = require("../shared/helpers");
const taskSetup_1 = require("../taskSetup");
const taskStore_1 = require("../../taskStore");
// trials
const trials_1 = require("../shared/trials");
const config_1 = require("./helpers/config");
function buildAdultReasoningTimeline(config, mediaAssets) {
    const preloadTrials = (0, helpers_1.createPreloadTrials)(mediaAssets).default;
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const timeline = [preloadTrials, initialTimeline];
    const corpus = (0, taskStore_1.taskStore)().corpora.stimulus;
    const translations = (0, taskStore_1.taskStore)().translations;
    const validationErrorMap = {};
    const cat = (0, taskStore_1.taskStore)().runCat;
    (0, taskStore_1.taskStore)('totalTestTrials', (0, helpers_1.getRealTrials)(corpus));
    const layoutConfigMap = {};
    for (const c of corpus) {
        const { itemConfig, errorMessages } = (0, config_1.getLayoutConfig)(c, translations, mediaAssets);
        layoutConfigMap[c.itemId] = itemConfig;
        if (errorMessages.length) {
            validationErrorMap[c.itemId] = errorMessages.join('; ');
        }
    }
    if (Object.keys(validationErrorMap).length) {
        console.error('The following errors were found');
        console.table(validationErrorMap);
        throw new Error('Something went wrong. Please look in the console for error details');
    }
    const trialConfig = {
        trialType: 'audio',
        responseAllowed: true,
        promptAboveButtons: true,
        task: config.task,
        layoutConfigMap,
        terminateCat: false,
    };
    const stimulusBlock = (trial) => {
        return {
            timeline: [(0, trials_1.afcStimulusTemplate)(trialConfig, trial)],
        };
    };
    let numOfTrials;
    if (cat) {
        const fullCorpus = (0, helpers_1.prepareCorpus)(corpus, false);
        const practice = [...fullCorpus.ipLight, ...fullCorpus.ipHeavy];
        numOfTrials = 8;
        practice.forEach((trial) => {
            timeline.push({ ...trials_1.fixationOnly, stimulus: `` });
            timeline.push(stimulusBlock(trial));
        });
    }
    else {
        numOfTrials = (0, taskStore_1.taskStore)().totalTrials;
    }
    for (let i = 0; i < numOfTrials; i++) {
        timeline.push({ ...trials_1.setupStimulus, stimulus: `` });
        timeline.push(stimulusBlock());
    }
    (0, taskSetup_1.initializeCat)();
    timeline.push((0, trials_1.taskFinished)());
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
